import { render, staticRenderFns } from "./CwpeQuotes.vue?vue&type=template&id=15ba2f87&"
import script from "./CwpeQuotes.vue?vue&type=script&lang=js&"
export * from "./CwpeQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports